import { render, staticRenderFns } from "./DetalheComponent3.vue?vue&type=template&id=e64e2b40&"
import script from "./DetalheComponent3.vue?vue&type=script&lang=js&"
export * from "./DetalheComponent3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports